<template>
  <div class="filter-block__group">
    <label v-if="showLabel" :for="field.attribute" class="filter-block__text">
      {{ fieldLabel || field.label }}
    </label>
    <slot name="field" />
  </div>
</template>

<script>
import { FieldLayoutMixin } from "stylemix-base";

export default {
  name: "FilterBlockLayout",
  mixins: [FieldLayoutMixin],
};
</script>
